export default __webpack_public_path__ + "static/media/top2-logo.1d2d3737.webp";